import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-hp',
  templateUrl: './work-hp.component.html',
  styleUrls: ['./work-hp.component.scss']
})

export class WorkHpComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

  //Project overview devices
  projectImgDevices = 'assets/img/hp/Hp-devices-3.png';
  altImgDevicesTitle = 'HP Devices'
  projectIcon='HP Devices'
}



// WEBPACK FOOTER //
// ./src/app/work-hp/work-hp.component.ts